module.exports = __webpack_public_path__ + "img/aanleg4.546b965b.jpg";